import { ApiError, api } from '../api';
import { type Lang, getLang, setLang as setI18nLang, t } from '../i18n';

const OPTIONS: { v: Lang; l: string }[] = [
  { v: 'he', l: 'עב' },
  { v: 'en', l: 'EN' },
  { v: 'ur', l: 'اردو' },
  { v: 'tl', l: 'TL' },
];

export function LangSwitch() {
  const current = getLang();

  async function pick(next: Lang) {
    if (next === current) return;
    setI18nLang(next);
    try {
      await api('/v1/me', {
        method: 'PATCH',
        body: JSON.stringify({ preferred_lang: next }),
      });
    } catch (e) {
      if (!(e instanceof ApiError)) throw e;
    }
    window.location.reload();
  }

  // Native <select> is the right primitive on mobile — iOS / Android
  // render it as a full-screen wheel which is faster and more accessible
  // than a hand-built popover. We just enlarge the hit-target so it
  // hits the 44×44 iOS HIG minimum.
  return (
    <select
      aria-label={t('Language')}
      value={current}
      onChange={(e) => void pick(e.target.value as Lang)}
      className="touch rounded-md border border-border bg-white px-3 text-sm font-medium text-foreground/80 shadow-sm hover:border-foreground focus:border-primary focus:outline-none focus:ring-2 focus:ring-ring/25"
    >
      {OPTIONS.map((o) => (
        <option key={o.v} value={o.v}>
          {o.l}
        </option>
      ))}
    </select>
  );
}
